import type { PriorityBand, TaskPriority } from '@/lib/api/types';
import type { MessageKey } from '@/lib/i18n';

/** Message keys, not text — the label depends on the reader's language. */
export const PRIORITY_LABELS: Record<TaskPriority, MessageKey> = {
  URGENT: 'priority.urgent',
  HIGH: 'priority.high',
  NORMAL: 'priority.normal',
  LOW: 'priority.low',
  NONE: 'priority.none',
};

export const BAND_LABELS: Record<PriorityBand, MessageKey> = {
  MUST_DO: 'band.mustDo',
  NORMAL: 'band.normal',
  IF_THERE_IS_TIME: 'band.ifThereIsTime',
};

/** Descending urgency — the order menus and pickers present. */
export const PRIORITY_ORDER: TaskPriority[] = [
  'URGENT',
  'HIGH',
  'NORMAL',
  'LOW',
  'NONE',
];

/** Mirrors PRIORITY_BANDS on the backend, for optimistic regrouping. */
export function bandFor(priority: TaskPriority): PriorityBand {
  if (priority === 'URGENT' || priority === 'HIGH') return 'MUST_DO';
  if (priority === 'NORMAL') return 'NORMAL';
  return 'IF_THERE_IS_TIME';
}
